import React from 'react';
import PropTypes from 'prop-types';
import styles, { mainCls } from './styles';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName/index';

const useStyles = createStyle(styles);

const ToggleSwitch = ({ id, label, enabled, onChange, className, txtCls }) => {
  const cls = useStyles();
  return (
    <label className={makeClassName([cls[`${mainCls}`], className])} id={id}>
      {txtCls ? <span className={txtCls}>{label}</span> : <>{label}</>}
      <input
        className={makeClassName([cls[`${mainCls}__input`]])}
        type="checkbox"
        defaultChecked={enabled}
        onChange={onChange}
      />
      <span className={makeClassName([cls[`${mainCls}__track`]])}>
        <span className={makeClassName([cls[`${mainCls}__peg`]])} />
      </span>
    </label>
  );
};

ToggleSwitch.propTypes = {
  /**
   * Identifier
   */
  id: PropTypes.string,
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * Set if the switch has to be turned on or off
   */
  enabled: PropTypes.bool,
  /**
   * Callback when the switch is changed
   */
  onChange: PropTypes.func,
  className: PropTypes.string,
  txtCls: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  id: '',
  label: 'text',
  enabled: true,
  onChange: () => {},
  className: '',
  txtCls: '',
};
export default ToggleSwitch;
